export const STATUSES = ["New", "Processing 1", "Processing 2", "Ready", "Delivered", "Cancelled"];

export const FINISHES = ["Gold Finish", "Rose Gold Finish", "Antique Gold", "Antique Brass", "Silver Finish", "Nickel Finish", "Chrome Finish", "Copper Finish", "Brass Finish", "PVD Finish", "Polishing", "Restoration", "Plating", "Painting", "Other"];

export const CATEGORIES = ["Ornament / Jewellery", "Idol / Statue", "Vessel / Utensil", "Antique Artifact", "Trophy / Award", "Hardware / Fitting", "Watch / Clock", "Cutlery", "Decor / Showpiece", "Furniture Part", "Other"];

export const CONDITIONS = ["Tarnished", "Dented", "Scratched", "Corroded", "Broken / Damaged", "Faded Finish", "Good (needs polish)", "Other"];

export const MATERIALS = ["Brass", "Copper", "Silver", "Gold", "Bronze", "Stainless Steel", "Iron", "Aluminium", "Mixed Metal", "Unknown / Other"];

export const PHOTO_TYPES = ["Before", "During Processing", "After", "Final Product", "Other"];

export const SURFACE_FINISHES = ["Glossy", "Matt", "Brushed"];

export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat",
  "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
  "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
  "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh",
  "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry",
];

export const STATUS_STYLES = {
  "New": "bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-950/60 dark:text-blue-300 dark:border-blue-900",
  "Processing 1": "bg-orange-50 text-orange-800 border-orange-200 dark:bg-orange-950/60 dark:text-orange-300 dark:border-orange-900",
  "Processing 2": "bg-violet-50 text-violet-800 border-violet-200 dark:bg-violet-950/60 dark:text-violet-300 dark:border-violet-900",
  "Ready": "bg-emerald-50 text-emerald-800 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-900",
  "Delivered": "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
  "Cancelled": "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/60 dark:text-red-300 dark:border-red-900",
  // Legacy statuses (existing older jobs keep these styles)
  "Received": "bg-green-50 text-green-800 border-green-200 dark:bg-green-950/60 dark:text-green-300 dark:border-green-900",
  "Inspection": "bg-yellow-50 text-yellow-800 border-yellow-200 dark:bg-yellow-950/60 dark:text-yellow-300 dark:border-yellow-900",
  "Processing": "bg-orange-50 text-orange-800 border-orange-200 dark:bg-orange-950/60 dark:text-orange-300 dark:border-orange-900",
  "Finishing": "bg-violet-50 text-violet-800 border-violet-200 dark:bg-violet-950/60 dark:text-violet-300 dark:border-violet-900",
  "Quality Check": "bg-cyan-50 text-cyan-800 border-cyan-200 dark:bg-cyan-950/60 dark:text-cyan-300 dark:border-cyan-900",
  "Closed": "bg-slate-100 text-slate-500 border-slate-200 dark:bg-slate-800/60 dark:text-slate-400 dark:border-slate-700",
};

export function waLink(number) {
  if (!number) return null;
  let digits = String(number).replace(/\D/g, "");
  if (digits.length === 10) digits = "91" + digits;
  return `https://wa.me/${digits}`;
}

export function fmtWeight(w) {
  if (w === null || w === undefined || w === "") return "";
  const v = parseFloat(String(w).replace(/\s*(kgs?|gms?|grams?|g)$/i, "").trim());
  if (isNaN(v)) return "";
  const kg = v >= 100 ? v / 1000 : v; // values >= 100 are legacy gram entries
  return `${parseFloat(kg.toFixed(3))} Kg`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true });
  } catch { return iso; }
}
